import VMInfo from './VMInfo';

/**
 * GatewayInfo is a thin wrapper around VMInfo for gateway mode.
 * This exists to maintain backward compatibility with existing imports.
 */
export default function GatewayInfo(props) {
  return <VMInfo {...props} title="Gateway" testId="gateway-info" variant="gateway" />;
}
